import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../Constant/colors";

const ReportsManagement = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [activeSection, setActiveSection] = useState(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: "#ffffff",
    padding: "20px",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    display: "flex",
    alignItems: "center",
    gap: "12px",
    minHeight: "100px",
    transition: "0.3s",
    cursor: "pointer",
  };

  const heading = {
    fontSize: "18px",
    fontWeight: "600",
    color: colors.grayDark,
  };

  const subText = {
    fontSize: "12px",
    color: colors.grayDark,
    opacity: 0.85,
    marginTop: "2px",
  };

  const iconStyle = {
    fontSize: "30px",
    minWidth: "40px",
  };

  const renderSubCard = (title, desc, icon, color, link) => (
    <Link to={link} className="flex">
      <div style={cardStyle} className="hover:scale-[1.02] w-full">
        <i className={icon} style={{ ...iconStyle, color }}></i>
        <div>
          <h2 style={heading}>{title}</h2>
          <p style={subText}>{desc}</p>
        </div>
      </div>
    </Link>
  );

  return (
    <div
      style={{ background: "#ffffff", minHeight: "100vh" }}
      className="flex justify-center items-start p-6"
    >
      <div className="w-full max-w-7xl">

        {/* MAIN GRID */}
        {!activeSection && (
          <div className={`grid gap-6 ${isMobile ? "grid-cols-1" : "grid-cols-3"}`}>

            {/* Fee Reports */}
            <div
              style={cardStyle}
              onClick={() => setActiveSection("fee")}
              className="hover:scale-[1.02]"
            >
              <i
                className="fas fa-money-bill-wave"
                style={{ ...iconStyle, color: "#3B82F6" }}
              ></i>
              <div>
                <h2 style={heading}>Fee Reports</h2>
                <p style={subText}>View and manage fee reports.</p>
              </div>
            </div>

            {/* Student Reports */}
            <div
              style={cardStyle}
              onClick={() => setActiveSection("student")}
              className="hover:scale-[1.02]"
            >
              <i
                className="fas fa-user-graduate"
                style={{ ...iconStyle, color: "#8B5CF6" }}
              ></i>
              <div>
                <h2 style={heading}>Student Reports</h2>
                <p style={subText}>Generate and view student reports.</p>
              </div>
            </div>

            {/* Staff Reports */}
            <div
              style={cardStyle}
              onClick={() => setActiveSection("staff")}
              className="hover:scale-[1.02]"
            >
              <i
                className="fas fa-chalkboard-teacher"
                style={{ ...iconStyle, color: "#F97316" }}
              ></i>
              <div>
                <h2 style={heading}>Staff Reports</h2>
                <p style={subText}>Access staff reports and analytics.</p>
              </div>
            </div>

            {/* Transport Reports */}
            <div
              style={cardStyle}
              onClick={() => setActiveSection("transport")}
              className="hover:scale-[1.02]"
            >
              <i
                className="fas fa-bus"
                style={{ ...iconStyle, color: "#10B981" }}
              ></i>
              <div>
                <h2 style={heading}>Transportation Reports</h2>
                <p style={subText}>View transportation reports.</p>
              </div>
            </div>
          </div>
        )}

        {/* FEE REPORTS SUB SECTION */}
        {activeSection === "fee" && (
          <>
            <button
              onClick={() => setActiveSection(null)}
              className="mb-6 text-sm font-semibold"
            >
              ← Back
            </button>

         <div className={`grid gap-6 ${isMobile ? "grid-cols-1" : "grid-cols-3"}`}>
              {renderSubCard(
                "By Class",
                "Fee report filtered by class.",
                "fas fa-layer-group",
                "#3B82F6",
                "/fee-report/by-class"
              )}
              {renderSubCard(
                "By Cash or Cheque",
                "Total Fee collection report.",
                "fas fa-coins",
                "#F59E0B",
                "/fee-report/by-cash"
              )}
              {renderSubCard(
                "Custom Reports",
                "Custom fee collection summary.",
                "fas fa-calendar-alt",
                "#6366F1",
                "/fee-report/custom"
              )}
              {renderSubCard(
                "Monthly Fee Register",
                "Shows remaining months for fee collection with paid/unpaid status.",
                "fas fa-book",
                "#10B981", // Tailwind green
                "/fee-report/monthly-register"
              )}
              {renderSubCard(
                "Fee Summary Report",
                "View total expected vs received fees by class and section.",
                "fas fa-file-invoice-dollar",  // icon related to money/invoice
                "#EF4444",                     // Tailwind red color for emphasis
                "/fee-report/summarize"
              )}
            </div>
          </>
        )}

        {/* STUDENT REPORT SUB SECTION */}
        {activeSection === "student" && (
          <>
            <button
              onClick={() => setActiveSection(null)}
              className="mb-6 text-sm font-semibold"
            >
              ← Back
            </button>

            <div className={`grid gap-6 ${isMobile ? "grid-cols-1" : "grid-cols-3"}`}>
              {renderSubCard(
                "Student Details",
                "Complete student information report.",
                "fas fa-id-card",
                "#8B5CF6",
                "/student-report/details"
              )}
              {renderSubCard(
                "Sibling Report",
                "View sibling relationship data.",
                "fas fa-users",
                "#EC4899",
                "/student-report/sibling"
              )}
            </div>
          </>
        )}

        {/* STAFF REPORT SUB SECTION */}
        {activeSection === "staff" && (
          <>
            <button
              onClick={() => setActiveSection(null)}
              className="mb-6 text-sm font-semibold"
            >
              ← Back
            </button>

            <div className={`grid gap-6 ${isMobile ? "grid-cols-1" : "grid-cols-3"}`}>
              {renderSubCard(
                "Staff Details",
                "Detailed staff information.",
                "fas fa-user-tie",
                "#F97316",
                "/staff-report/details"
              )}

            </div>
          </>
        )}

        {/* TRANSPORT SUB SECTION */}
        {activeSection === "transport" && (
          <>
            <button
              onClick={() => setActiveSection(null)}
              className="mb-6 text-sm font-semibold"
            >
              ← Back
            </button>

            <div className={`grid gap-6 ${isMobile ? "grid-cols-1" : "grid-cols-3"}`}>
              {renderSubCard(
                "Route Report",
                "Bus route details report.",
                "fas fa-route",
                "#10B981",
                "/transportation-report/routes"
              )}
              {renderSubCard(
                "Vehicle Report",
                "Vehicle and usage report.",
                "fas fa-bus-alt",
                "#0EA5E9",
                "/transportation-report/vehicles"
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ReportsManagement;